import { p as proxyCustomElement, H, h, a as Host } from './index.js';

const SIZE_MAP = {
    0: 0,
    '3xs': 0.125,
    '2xs': 0.25,
    xs: 0.5,
    sm: 0.75,
    md: 1,
    lg: 1.25,
    xl: 1.5,
    '2xl': 2,
    '3xl': 2.5,
    '4xl': 3,
};
function parseSizes(__sizeArg, sizes) {
    const sizesFromObj = {};
    if (typeof sizes.top !== 'undefined') {
        sizesFromObj.top = SIZE_MAP[sizes.top];
    }
    if (typeof sizes.right !== 'undefined') {
        sizesFromObj.right = SIZE_MAP[sizes.right];
    }
    if (typeof sizes.bottom !== 'undefined') {
        sizesFromObj.bottom = SIZE_MAP[sizes.bottom];
    }
    if (typeof sizes.left !== 'undefined') {
        sizesFromObj.left = SIZE_MAP[sizes.left];
    }
    const sizeArg = !Array.isArray(__sizeArg) ? [__sizeArg] : __sizeArg;
    const sizesFromArr = {};
    switch (sizeArg.length) {
        case 4: {
            const [top, right, bottom, left] = sizeArg;
            if (typeof top !== 'undefined') {
                sizesFromArr.top = SIZE_MAP[top];
            }
            if (typeof right !== 'undefined') {
                sizesFromArr.right = SIZE_MAP[right];
            }
            if (typeof bottom !== 'undefined') {
                sizesFromArr.bottom = SIZE_MAP[bottom];
            }
            if (typeof left !== 'undefined') {
                sizesFromArr.left = SIZE_MAP[left];
            }
            break;
        }
        case 3: {
            const [top, hor, bottom] = sizeArg;
            if (typeof top !== 'undefined') {
                sizesFromArr.top = SIZE_MAP[top];
            }
            if (typeof hor !== 'undefined') {
                sizesFromArr.right = SIZE_MAP[hor];
            }
            if (typeof bottom !== 'undefined') {
                sizesFromArr.bottom = SIZE_MAP[bottom];
            }
            if (typeof hor !== 'undefined') {
                sizesFromArr.left = SIZE_MAP[hor];
            }
            break;
        }
        case 2: {
            const [ver, hor] = sizeArg;
            if (typeof ver !== 'undefined') {
                sizesFromArr.top = SIZE_MAP[ver];
            }
            if (typeof hor !== 'undefined') {
                sizesFromArr.right = SIZE_MAP[hor];
            }
            if (typeof ver !== 'undefined') {
                sizesFromArr.bottom = SIZE_MAP[ver];
            }
            if (typeof hor !== 'undefined') {
                sizesFromArr.left = SIZE_MAP[hor];
            }
            break;
        }
        case 1: {
            const [all] = sizeArg;
            if (typeof all !== 'undefined') {
                sizesFromArr.top = SIZE_MAP[all];
            }
            if (typeof all !== 'undefined') {
                sizesFromArr.right = SIZE_MAP[all];
            }
            if (typeof all !== 'undefined') {
                sizesFromArr.bottom = SIZE_MAP[all];
            }
            if (typeof all !== 'undefined') {
                sizesFromArr.left = SIZE_MAP[all];
            }
        }
    }
    return {
        ...sizesFromArr,
        ...sizesFromObj,
    };
}

const boxCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;max-width:100%;min-width:0;width:auto}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host([wrap]){flex-wrap:wrap}:host([orientation=horizontal]){flex-direction:row}:host([orientation=vertical]){flex-direction:column}:host([gutter=\"3xs\"]){gap:.125rem}:host([gutter=\"2xs\"]){gap:.25rem}:host([gutter=xs]){gap:.5rem}:host([gutter=sm]){gap:.75rem}:host([gutter=md]){gap:1rem}:host([gutter=lg]){gap:1.25rem}:host([gutter=xl]){gap:1.5rem}:host([gutter=\"2xl\"]){gap:2rem}:host([gutter=\"3xl\"]){gap:2.5rem}:host([gutter=\"4xl\"]){gap:3rem}:host([align=start]){align-items:flex-start}:host([align=center]){align-items:center;text-align:initial}:host([align=end]){align-items:flex-end}:host([align=stretch]){align-items:stretch}:host([align=baseline]){align-items:baseline}:host([justify=start]){justify-content:flex-start}:host([justify=center]){justify-content:center;text-align:initial}:host([justify=end]){justify-content:flex-end}:host([justify=space-between]){justify-content:space-between}:host([justify=space-around]){justify-content:space-around}:host([justify=space-evenly]){justify-content:space-evenly}";

function setStyle(sizes, el, property) {
    if (!(sizes && el)) {
        return;
    }
    const T = `${property}Top`;
    const R = `${property}Right`;
    const B = `${property}Bottom`;
    const L = `${property}Left`;
    if (typeof sizes.top !== 'undefined') {
        el.style[T] = `${sizes.top}rem`;
    }
    if (typeof sizes.right !== 'undefined') {
        el.style[R] = `${sizes.right}rem`;
    }
    if (typeof sizes.bottom !== 'undefined') {
        el.style[B] = `${sizes.bottom}rem`;
    }
    if (typeof sizes.left !== 'undefined') {
        el.style[L] = `${sizes.left}rem`;
    }
}
const WuiBox = /*@__PURE__*/ proxyCustomElement(class WuiBox extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Box orientation
         */
        this.orientation = 'vertical';
        /**
         * Enable or disable flex-wrap
         */
        this.wrap = false;
    }
    watchPadding() {
        this.setPadding();
    }
    componentDidLoad() {
        this.setPadding();
        this.setMargin();
    }
    setPadding() {
        setStyle(parseSizes(this.padding, {
            top: this.paddingTop,
            right: this.paddingRight,
            bottom: this.paddingBottom,
            left: this.paddingLeft,
        }), this.elm, 'padding');
    }
    setMargin() {
        setStyle(parseSizes(this.margin, {
            top: this.marginTop,
            right: this.marginRight,
            bottom: this.marginBottom,
            left: this.marginLeft,
        }), this.elm, 'margin');
    }
    render() {
        return (h(Host, { key: '1e70cf30bfcbe8af162aac12a6b068c20a216482' }, h("slot", { key: 'de7493a39e34e9bad94dd00e31ce4f7a2f1e81dc' })));
    }
    get elm() { return this; }
    static get watchers() { return {
        "padding": ["watchPadding"]
    }; }
    static get style() { return boxCss; }
}, [257, "wui-box", {
        "padding": [8],
        "paddingTop": [8, "padding-top"],
        "paddingRight": [8, "padding-right"],
        "paddingBottom": [8, "padding-bottom"],
        "paddingLeft": [8, "padding-left"],
        "margin": [8],
        "marginTop": [8, "margin-top"],
        "marginRight": [8, "margin-right"],
        "marginBottom": [8, "margin-bottom"],
        "marginLeft": [8, "margin-left"],
        "orientation": [513],
        "align": [513],
        "justify": [513],
        "gutter": [520],
        "wrap": [516]
    }, undefined, {
        "padding": ["watchPadding"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-box"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-box":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiBox);
            }
            break;
    } });
}
defineCustomElement();

export { WuiBox as W, defineCustomElement as d };
